import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { cancelSubscription } from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { SubscriptionProductIsSelected } from "@TKCCP/Types/ApiModels";

type cancelSubscriptionParameter = {
    SubscriptionIdList: string[];
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<cancelSubscriptionParameter, cancelSubscriptionParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        SubscriptionIdList: props.parameter.SubscriptionIdList,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await cancelSubscription(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const cancelSubscriptionForm = createHandlerChainRunner(chain, "cancelSubscriptionForm");
export default cancelSubscriptionForm;
